/* 
自定义接口,请在此定义
 */
import {
	ElMessage
} from 'element-plus';
import http from '@/../src/api/http.js'
import store from '../store/index.js'
import CryptoJS from 'crypto-js'

function CheckAuthority(page, callBack) {
	http.get('Base/CheckAuthority', {
		page
	}, true).then(rslt => {
		if (callBack != null)
			callBack(rslt)
	})
}

// 同步本地缓存的用户信息
function SynCacheInfo(callBack) {
	http.get("/Student/GetClientInfo", {}, true).then((res) => {
		if (res.code == 1) {
			let userInfo = res.data.UserInfo
			let xunKeType = res.data.XuanKeType
			let model = res.data.Model
			store.commit("setUserInfo", userInfo)
			store.commit("set_XuanKeType", xunKeType)
			store.commit("set_GKModel", model)
			let obj = {}
			obj.AreaID = userInfo.AreaID
			obj.AreaName = userInfo.AreaName
			store.commit("set_UserSetArea", obj)
			store.commit("set_StuTags", res.data.Tags);
		} else {
			ElMessage.error(res.msg)
		}
		if (callBack != null)
			callBack()
	})
}

function IsCanViewJieDu() {
	let isCan = false
	let isVirtual = store.getters.get_isVirtualLogin()
	if (isVirtual || this.IsPeiXuan())
		isCan = true
	return isCan
}

function IsCanAddJieDu() {
	let isCan = false
	let isVirtual = store.getters.get_isVirtualLogin()
	// let isZiYing = store.getters.get_IsZiYing()
	// //虚拟登录，并且具有自营机构的助理，才可添加解读。通过角色权限比较彻底，此处暂时这样改。
	// if (isVirtual && isZiYing) {
	// 	isCan = true
	// }
	if (isVirtual)
		isCan = true
	return isCan
}
//是否为家庭培训版用户
function IsPeiXuan() {
	let val = 0
	let uInfo = store.getters.getUserInfo()
	if (uInfo) {
		val = uInfo.IsPeixun
	}
	return val
}


function GetEncrypTxt(key, txt, callBack) {
	http.post('/base/GetEncrypTxt', {
		txt: txt,
		key: key
	}, false).then(rsl => {
		if (rsl.code == 1) {
			if (callBack) {
				let entxt = rsl.data
				key = key + '7395821460583241'
				key = key.substring(0, 16)
				if (entxt)
					txt = this.DecryptAES(entxt, key, 'icctqyapyprdfrbw')
				else
					txt = ''
				callBack(txt)
			}
		} else {
			ElMessage.error(rsl.msg)
		}
	})
}

function DecryptAES(encryptedText, key, iv) {
	// 参数检查 
	if (!encryptedText) throw new Error("加密文本不能为空");
	if (!key) throw new Error("密钥不能为空");
	if (!iv) throw new Error("初始化向量不能为空");

	// 将Base64编码的加密文本转换为CryptoJS格式 
	const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedText);

	// 准备密钥和初始化向量 
	const keyBytes = CryptoJS.enc.Utf8.parse(key);
	const ivBytes = CryptoJS.enc.Utf8.parse(iv);

	// 解密配置 
	const decryptOptions = {
		iv: ivBytes,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.Pkcs7
	};

	// 执行解密 
	const decrypted = CryptoJS.AES.decrypt({
			ciphertext: encryptedBytes
		},
		keyBytes,
		decryptOptions
	);

	// 返回UTF-8格式的解密结果 
	return decrypted.toString(CryptoJS.enc.Utf8);
}


export default {
	CheckAuthority,
	SynCacheInfo,
	IsCanAddJieDu,
	IsCanViewJieDu,
	IsPeiXuan,
	GetEncrypTxt,
	DecryptAES
}